import { useEffect } from "react";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { updateUser } from "../store/api/Users";
import Loader from "react-loader-spinner";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useForm } from "react-hook-form";
import { Check2Square } from 'react-bootstrap-icons';
const UserProfile = () => {
    const history = useHistory();
    const roleList = JSON.parse(localStorage.getItem("RoleList"));
    const userInfo = JSON.parse(localStorage.getItem("UserInfo"));
    const { register, handleSubmit, errors } = useForm();
    let isLoadingSaved = useSelector(state => state.loading?.isLoading);
    const translateRole = (roleName) => {
        switch (roleName) {
            case "Reception":
                return "کاربر پذیرش";
            case "Staff":
                return "تکنسین";
            case "Agent":
                return "نماینده";
            default:
                return "";
        }
    }
    const dispatch = useDispatch();
    const save = (data) => {
        const onSuccess = () => {
            if (data.Password !== "") {
                localStorage.removeItem("token");
                history.push("/");
            }
        }
        dispatch(updateUser(data, onSuccess));

    }
    useEffect(() => {
        document.body.classList = "notMain";
    }, []);
    return (
        <div className="container-fluid mt-2">
            <br />
            <div className="card">
                <div className="card-header headerStyle">پروفایل کاربر</div>
                <div className="card-body bodyStyle" style={{ textAlign: "right" }}>
                    <form onSubmit={handleSubmit(save)}>
                        <div className="row">
                            <div className="form-group col-md-3">
                                <label>نام کامل</label>
                                <input type="text" className="form-control" name="Name" ref={register({required:true})} defaultValue={userInfo?.Name}></input>
                                {errors?.Name && <span className="errors">نام کامل الزامی است</span>}
                            </div>
                            <div className="form-group col-md-3">
                                <label>نام کاربری</label>
                                <input type="text" className="form-control" name="UserName"  ref={register({required:true})} defaultValue={userInfo?.UserName}></input>
                                {errors?.UserName && <span className="errors">نام کاربری الزامی است</span>}
                            </div>
                            <div className="form-group col-md-3">
                                <label>گذرواژه</label>
                                <input type="password" name="Password"  ref={register({})} className="form-control"></input>
                            </div>
                            <div className="form-group col-md-3">
                                <label>فهرست نقش ها</label>
                                <select className="form-control">
                                    {roleList && Array.isArray(roleList) && roleList.map((item, i) => <option key={i}>{translateRole(item)}</option>)}
                                </select>
                            </div>
                            <div>
                                <Button className="mt-2 group-Btn" type="submit" disabled={isLoadingSaved}>
                                    <>
                                    {isLoadingSaved ? <Loader type="BallTriangle" color="white" height={15} width={15} style={{display:"inline-block"}}/>:
                                    <Check2Square size={17}/>}&nbsp;
                                    ثبت اطلاعات
                                    </>
                                    </Button>
                                    
                            </div>
                        </div>
                    </form>

                </div>
            </div>
        </div>)

}
export default UserProfile;